import type { MailboxInfo } from 'owa-client-types';
import isFeatureEnabled from './isFeatureEnabled';

export default function isImmutableidEnabledForMailbox(
    mailboxInfo?: MailboxInfo,
    dontThrowErrorIfNotInitialized?: boolean
): boolean {
    return isFeatureEnabled('fwk-immutable-ids', mailboxInfo, dontThrowErrorIfNotInitialized);
}
